import React from 'react';
import BrandRow from './BrandRow';
import FilterableTable from '../filters/FilterableTable';

const BrandTable = ({
  dispatch,
  brandReducer,
  findAllBrandsPageble,
  updateBrand,
  deleteBrand,
  clearValidationErrors,
}) => {
  const { brandList, totalElements } = brandReducer;

  let brandNameList = brandList.map((brand, index) => (
    <BrandRow
      key={brand.id}
      brand={brand}
      deleteBrand={deleteBrand}
      updateBrand={updateBrand}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      brandReducer={brandReducer}
    />
  ));

  const columns = [
   
    {
      id: 'Brend ',
      name: 'Brend ',
      filter: {
        field: 'brandName',
        value: '',
        type: 'LIKE',
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' },
  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllBrandsPageble}
        rows={brandNameList}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default BrandTable;
